@let serviceValue = service();
@let itemLabelResolverValue = itemLabelResolver();
<ng-container *transloco="let globalTranslate">
  <ng-container *transloco="let t; prefix: i18nScope + '.FIELD.AUTOCOMPLETE'">
    @let selectedItems = delegatedControl.value | ensureItemsArray;

    <span (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
      <mat-form-field [class.max-md:w-full]="fullWidthOnMobile()" [class.md:w-full]="fullWidth()">
        @let translatedLabel = label() | resolveTranslateAbleText;
        <mat-label>{{ translatedLabel }}</mat-label>
        <mat-select
          #triggerMultipleSelectedPanel="cdkOverlayOrigin"
          cdkOverlayOrigin
          hideSingleSelectionIndicator="false"
          msInfiniteScroll
          [attr.name]="nameAttribute()"
          [compareWith]="equalityCheckerFn()"
          [complete]="hasNextPage() === false"
          [formControl]="delegatedControl"
          [multiple]="multiple()"
          [panelClass]="panelClass()"
          [placeholder]="translatedLabel"
          (blur)="onBlur()"
          (closed)="onClose()"
          (infiniteScroll)="doScroll$.next()"
          (opened)="onOpen()"
        >
          <mat-option>
            <ngx-mat-select-search
              [formControl]="searchControl"
              [id]="`${nameAttribute()}-search-input`"
              [placeholderLabel]="globalTranslate(searchPlaceholder())"
              [searching]="loading()"
            >
              <span ngxMatSelectNoEntriesFound>
                @if (searchControl.valid) {
                  @if (loading()) {
                    {{ t('LOADING') }}
                  } @else {
                    {{ globalTranslate(notFoundText(), { searchText: searchControl.value }) }}
                  }
                }
              </span>

              <mat-icon customMatSvgIcon="pct-mdi-close-circle" ngxMatSelectSearchClear />
            </ngx-mat-select-search>
            @if (searchControl.invalid && loading() === false) {
              <div class="mat-error-without-form-field my-2">
                <mat-error
                  [control]="searchControl"
                  [overrideErrors]="searchControlOverrideErrors()"
                />
              </div>
            }
          </mat-option>
          <!-- This is always necessary here, otherwise the selected items won’t appear in the input. -->
          @if (selectedItems.length > 0) {
            @for (item of selectedItems; track trackResolveEntityId(item)) {
              <mat-option [value]="item">
                {{ item | resolveItemLabel: serviceValue : itemLabelResolverValue }}
              </mat-option>
            }
          }
          @for (
            item of list() | removeSelectedItems: selectedItems : serviceValue;
            track trackResolveEntityId(item)
          ) {
            <mat-option [value]="item">
              <span
                [innerHTML]="
                  item
                    | resolveItemLabel: serviceValue : itemLabelResolverValue
                    | markSearchText: searchControl.value
                    | sanitizeHtml
                "
              ></span>
            </mat-option>
          }
          @if (loading() && page > 1) {
            <mat-option disabled>{{ t('LOADING') }}</mat-option>
          }
        </mat-select>
        <mat-error [control]="delegatedControl" [overrideErrors]="overrideErrors()" />
        <button
          class="mx-2"
          mat-icon-button
          matSuffix
          type="button"
          [disabled]="(delegatedControl.value | isDisabledClearButton) || delegatedControl.disabled"
          (click)="clearControl(delegatedControl, $event)"
          ><mat-icon customMatSvgIcon="pct-mdi-close-circle"
        /></button>
      </mat-form-field>
    </span>
    @if (multiple()) {
      <ng-template
        cdkConnectedOverlay
        cdkConnectedOverlayDisposeOnNavigation="true"
        cdkConnectedOverlayMinHeight="40px"
        cdkConnectedOverlayMinWidth="100px"
        [cdkConnectedOverlayOpen]="isOpenMultipleSelectedPanel()"
        [cdkConnectedOverlayOrigin]="triggerMultipleSelectedPanel"
        (detach)="onMouseLeave()"
        (overlayOutsideClick)="onMouseLeave()"
      >
        <div
          class="mat-select-panel-animations-enabled mat-mdc-select-panel mdc-menu-surface mdc-menu-surface--open mat-primary !p-2 md:max-w-[600px]"
          [ngClass]="multipleSelectedPanelClass()"
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
        >
          <mat-chip-set>
            @for (selectedItem of selectedItems; track trackResolveEntityId(selectedItem)) {
              <mat-chip (removed)="onRemoveSelected(selectedItem)">
                {{ selectedItem | resolveItemLabel: serviceValue : itemLabelResolverValue }}
                <button matChipRemove type="button">
                  <mat-icon customMatSvgIcon="pct-mdi-delete" />
                </button>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
      </ng-template>
    }
  </ng-container>
</ng-container>
